import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminManualReferralsApi } from '../services/adminManualReferralsApi';
import { manualReferralSearchKeys } from './useManualReferralEntitySearch';

// Feature 101: manual contact→account linking (the path for contacts entered
// without an email). Invalidates entity search so the linked contact stops
// appearing as a provisional result.
export const useLinkManualProfessionalContact = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, { contactId: string; userId: string }>({
    mutationFn: ({ contactId, userId }) =>
      adminManualReferralsApi.linkManualProfessionalContact(contactId, userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: manualReferralSearchKeys.all });
    },
  });
};
